module.exports = __webpack_public_path__ + "img/whitelabelpayments-logo.3a1ff592.svg";